<template>
  <a
    class="underline hover:text-teal-100 whitespace-nowrap flex flex-row"
    :href="`tel:${settings?.phone.value}`"
  >
    <Phone class="w-4 h-4 mr-1" />
    {{ settings?.phone.value }}
  </a>
</template>
<script setup lang="ts">
import { useSettingsStore } from "~/stores/settingsStore";
import { Phone } from "@element-plus/icons-vue";

const { settings } = useSettingsStore();

defineProps({
  icon: {
    default: false,
    type: Boolean,
  },
});
</script>
